export const PAGES = {
  WELCOME: {
    name: "welcome_page",
  },
  API: {
    name: "api_page",
  },
};
